import { firstValueFrom, take } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

export const publicUrls = ['/v1/products', '/v1/check_email', '/v1/register_keycloak', '/v1/register'];
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private readonly http = inject(HttpClient);

  private apiUrl = environment.apiUrl;

  //Register data
  registerUserKC(payload: any): Promise<any> {
    return firstValueFrom(this.http.post(
      `${this.apiUrl}/v1/register_keycloak`,
      payload).pipe(take(1)));
  }

  registerUserData(payload: any): Promise<any> {
    return firstValueFrom(this.http.post(
      `${this.apiUrl}/v1/register`,
      payload).pipe(take(1)));
  }

  registerSubscription(payload: any): Promise<any> {
    return firstValueFrom(this.http.post(
      `${this.apiUrl}/v1/subscription`,
      payload).pipe(take(1)));
  }

  checkoutOrder(payload: any): Promise<any> {
    return firstValueFrom(this.http.post(
      `${this.apiUrl}/v1/checkout`,
      payload).pipe(take(1)));
  }

  checkoutTrialOrder(payload: any): Promise<any> {
    return firstValueFrom(this.http.post(
      `${this.apiUrl}/v1/checkout/free_trial`,
      payload).pipe(take(1)));
  }

  //Cancel data
  cancelOrder(payload: any): Promise<any> {
    return firstValueFrom(this.http.post(
      `${this.apiUrl}/v1/cancel/recurrent_payment`,
      payload).pipe(take(1)));
  }

  //Validate data
  checkCouponData(payload: any): Promise<any> {
    return firstValueFrom(this.http.post(
      `${this.apiUrl}/v1/coupon`,
      payload).pipe(take(1)));
  }

  checkEmail(payload: any): Promise<any> {
    return firstValueFrom(this.http.post(
      `${this.apiUrl}/v1/check_email`,
      payload).pipe(take(1)));
  }

  checkoutCheck(payload: any): Promise<any> {
    return firstValueFrom(this.http.post(
      `${this.apiUrl}/v1/checkout/check`,
      payload).pipe(take(1)));
  }

  checkCPFAndCNPJ(payload: any): Promise<any> {
    return firstValueFrom(this.http.post(
      `${this.apiUrl}/v1/register/check_cpf_cnpj`,
      payload).pipe(take(1)));
  }

  checkShoppingCartValidity(payload: any): Promise<any> {
    return firstValueFrom(this.http.post(
      `${this.apiUrl}/v1/suporte_table/permissions`,
      payload).pipe(take(1)));
  }

  //Get data
  getUserData(): Promise<any> {
    return firstValueFrom(this.http.get(
      `${this.apiUrl}/v1/user_data`).pipe(take(1)));
  }

  getProductData(): Promise<any> {
    return firstValueFrom(this.http.get(
      `${this.apiUrl}/v1/products`).pipe(take(1)));
  }

  getFreeTrialProductData(): Promise<any> {
    return firstValueFrom(this.http.get(
      `${this.apiUrl}/v1/products/free_trial`).pipe(take(1)));
  }

  getOrdersData(payload: any): Promise<any> {
    return firstValueFrom(this.http.post(
      `${this.apiUrl}/v1/payment_data`,
      payload).pipe(take(1)));
  }

  getInstallments(payload: any): Promise<any> {
    return firstValueFrom(this.http.post(
      `${this.apiUrl}/v1/installments`,
      payload).pipe(take(1)));
  }
}
